import React, { useContext } from 'react';
import { IFrame as Iframe, TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import config from '../../../configs/config';
import SyncUpProductContext from '../../../context/SyncUpProductContext';

const {
  iframePierTicketingTrackerURL,
  iframePierTicketingWatchURL,
  iframePierTicketingDriveURL
} = config.powerBiSettings;

function PierTicketingMetrics() {
  const syncUpProductContext = useContext(SyncUpProductContext);
  const iframe = () => {
    switch (syncUpProductContext.syncUpAppName) {
      case 'TRACKER':
        return iframePierTicketingTrackerURL;
      case 'KIDSWATCH':
        return iframePierTicketingWatchURL;
      case 'DRIVE':
        return iframePierTicketingDriveURL;
      default:
        return '';
    }
  };

  return (
    <TmoCard>
      <Iframe src={iframe()} width="100%" height="836px" />
    </TmoCard>
  );
}

export default PierTicketingMetrics;
